module.exports = __webpack_public_path__ + "videos/ipad-test.d11e051.mp4";